import { Box } from '@chakra-ui/react'
import { useAtom } from 'jotai'

import HeadsetMic from '@/components/assets/HeadsetMic'
import { chatStatusAtom } from '@/store/gigiChat/Visuals'

const AgentHeadset = ({ chatId }: { chatId: string }) => {
    const [chatStatus] = useAtom(chatStatusAtom)

    const color = chatStatus?.asyncProcesses.some((process) => process.chatId === chatId)
        ? 'var(--chakra-colors-green-500)'
        : 'var(--chakra-colors-gray-600)'

    return (
        <Box className="message-icon">
            <HeadsetMic style={{ marginRight: '8px', display: 'inline-flex' }} color={color} />{' '}
        </Box>
    )
}

export default AgentHeadset
